import {
    ref,
    onValue,
    onChildAdded,
    onChildChanged,
    onChildRemoved,
    off,
    set,
    update,
    remove,
    push,
} from 'firebase/database';
import { RealtimeDB as db } from './init';

// Write or replace data
export const writeData = async (path, data) => {
    try {
        await set(ref(db, path), data);
        console.log(`Data written at: ${path}`);
    } catch (err) {
        console.error("Error writing data:", err);
    }
};

// Update partial data
export const updateData = async (path, data) => {
    try {
        await update(ref(db, path), data);
        console.log(`Data updated at: ${path}`);
    } catch (err) {
        console.error("Error updating data:", err);
    }
};

// Push new child under a list
export const pushData = async (path, data) => {
    try {
        const newRef = push(ref(db, path));
        await set(newRef, data);
        return newRef.key;
    } catch (err) {
        console.error("Error pushing data:", err);
    }
};

// Remove data
export const removeData = async (path) => {
    try {
        await remove(ref(db, path));
    } catch (err) {
        console.error("Error removing data:", err);
    }
};

// Subscribe to all value changes
export const subscribeToValue = (path, callback) => {
    const dataRef = ref(db, path);
    onValue(dataRef, (snapshot) => {
        callback(snapshot.val());
    });

    return () => off(dataRef); // unsubscribe function
};

// Subscribe to child-level changes
export const subscribeToChildren = (path, handlers = {}) => {
    const dataRef = ref(db, path);

    const { onAdd, onChange, onRemove } = handlers;

    if (onAdd) onChildAdded(dataRef, (snap) => onAdd(snap.key, snap.val()));
    if (onChange) onChildChanged(dataRef, (snap) => onChange(snap.key, snap.val()));
    if (onRemove) onChildRemoved(dataRef, (snap) => onRemove(snap.key));

    return () => off(dataRef); // unsubscribe all
};